<ion-app>
  <app-side-menu *ngIf="appService?.canShowMenu"></app-side-menu>
  <ion-router-outlet id="main-content"></ion-router-outlet>
  <app-error-modal></app-error-modal>
</ion-app>